export function replaceDOMElements() {

    function changeDOMElementPosition(parentElement, domElement, fromElement, whereElement, breakpoint = 1024) {
        document.querySelectorAll(parentElement).forEach(parent => {
            if (parent) {
                const elem = parent.querySelector(domElement);
                if (elem) {
                    const fromElementDOM = parent.querySelector(fromElement);
                    const whereElementDOM = parent.querySelector(whereElement) || parent;

                    if (window.innerWidth <= breakpoint && !elem.classList.contains('inserted')) {
                        whereElementDOM.appendChild(elem);
                        elem.classList.add('inserted');
                    }
                    if (window.innerWidth >= breakpoint && elem.classList.contains('inserted')) {
                        fromElementDOM.appendChild(elem);
                        elem.classList.remove('inserted');
                    }
                }
            }
        });
    }

    window.addEventListener('load', function () {
        changeDOMElementPosition('.awards-section', '.button-inside-heading', '.awards-heading', '.blurred-block');
        changeDOMElementPosition('.awards-section', '.button-inside-description', '.awards-description', '.blurred-block');
    });

    window.addEventListener('resize', function () {
        changeDOMElementPosition('.awards-section', '.button-inside-heading', '.awards-heading', '.blurred-block');
        changeDOMElementPosition('.awards-section', '.button-inside-description', '.awards-description', '.blurred-block');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/replaceDOMElements.js